import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

export const Distributor = styled.div`
  padding: 10px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;

  cursor: pointer;
  text-decoration: underline;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.black};
  }
`;

export const OptInWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const OptInLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
`;

export const TooltipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.neutral.gray4};
  color: ${({ theme }) => theme.colors.neutral.white};
  font-size: 10px;
  font-weight: bold;
  cursor: help;
`;
